import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
import { CardEtapaInicial } from '@/pages/proposta/etapa-informacoes-iniciais/card-etapa-inicial'
import { VagaPadraoTrigger } from '@/pages/proposta/etapa-informacoes-iniciais/vaga-padrao/vaga-padrao-trigger'
import { Icon } from '@/shared/components/icon'
import { StringUtils } from '@/shared/utils'

const getVariant = (completed: boolean, optional?: boolean) => {
  let variant: 'completed' | 'default' | 'optional' = 'default'
  if (!completed && optional) variant = 'optional'
  if (completed) variant = 'completed'
  return variant
}

export const CardVagaPadrao = () => {
  const { watch } = useFormContext<TPropostaSchemaInput>()
  const { t } = useTranslation('proposta')

  const acessorioNaoObrigatorioNaUnidade = !watch('informacoesIniciais.simulacaoUnidade.produto.acessorioObrigatorio')
  const naoPossuiAcessorioExtraNaProposta = !watch('informacoesIniciais.simulacoesAcessorios').length
  const vagaSelecionada = watch('informacoesIniciais.vagaIds')
  const variant = getVariant(
    !!vagaSelecionada.length,
    acessorioNaoObrigatorioNaUnidade && naoPossuiAcessorioExtraNaProposta,
  )
  const completed = variant === 'completed'
  const vagaDeTrocaSelecionada = vagaSelecionada.some((vaga) => vaga.substituiVagaPadrao)

  return (
    <CardEtapaInicial variant={variant}>
      <CardEtapaInicial.Content
        label={t('informacoes_iniciais.cards.vaga_padrao.titulo')}
        description={t('informacoes_iniciais.cards.vaga_padrao.vincule')}
      >
        {completed && (
          <p className="grid grid-cols-[16px_1fr] gap-1 text-xs text-green-800">
            <Icon name="check" className="h-4 w-4" />
            {vagaDeTrocaSelecionada ? (
              <span className="text-nunito tracking-wide text-wrap">
                {t('informacoes_iniciais.cards.vaga_padrao.trigger.trocar_vaga')}
              </span>
            ) : (
              <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                {StringUtils.singularPlural(
                  vagaSelecionada.length,
                  t('informacoes_iniciais.cards.vaga_padrao.vinculada'),
                  t('informacoes_iniciais.cards.vaga_padrao.vinculadas'),
                )}
                {vagaSelecionada.map((v) => v.descricao).join(', ')}
              </span>
            )}
          </p>
        )}
      </CardEtapaInicial.Content>
      <CardEtapaInicial.Action>
        <VagaPadraoTrigger />
      </CardEtapaInicial.Action>
    </CardEtapaInicial>
  )
}
